/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { forwardRef } from "react";
import Button from "@mui/material/Button";

const ButtonOutlined = forwardRef((props, ref) => {

    const commonProps = {
        className: `outlined ${props.className ? props.className : ""}`,
        variant: "outlined",
        color: "primary",
    };

    //  Combine ClassName from "default" and "props"
    const asArray = Object.entries(props);
    const filtered = asArray.filter(([key]) => key !== "className");
    const propsFilter = Object.fromEntries(filtered);

    const allProps = {
        ...commonProps,
        ...propsFilter,
    };

    return (
        <Button ref={ref} {...allProps}>
            {props?.label}
        </Button>
    );
});

ButtonOutlined.displayName = "ButtonOutlined";
export { ButtonOutlined };
